//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EspecialidadesAPI from '@/api/promotores/cursos/especialidades.api'
import CursosAPI from '@/api/promotores/cursos.api'
import CursoForm from './CursoForm'
import ColumnsSelect from '@/components/ColumnsSelect'

export default {
	components: { ColumnsSelect },

  data() {
    return {
			visible_columns: [
				'id', 'nombre', 'categoria', 'especialidades', 'documento', 'video', 'created_at'
			],
			columns: [
				{ name: "id", label: "Id", field: "id", sortable: true, align: "left", style: "width: 10px", required: true },
				{ 
					name: 'nombre', 
					field: 'nombre', 
					label: 'Nombre', 
					sortable: true, 
					required: true,
					align: "left",
					classes: "bg-grey-2 ellipsis",
          style: "width: 350px",
          headerClasses: "bg-primary text-white",
				},
				{ name: 'examen', field: 'examen', label: 'Examen', align: 'left', },
				{ name: 'categoria', field: 'categoria', label: 'Categoria', align: 'left', },
				{ name: 'especialidades', field: 'especialidades', label: 'Especialidades', align: 'left', },
				{ name: "video", label: "Vídeo", field: "video", align: "center", style: 'width: 10px' },
				{ name: "documento", label: "Documento", field: "documento", align: "center", style: 'width: 10px' },
				{ name: "destacado", label: "Destacado", field: "destacado", align: "left", },
				{ name: "created_at", label: "Creación", field: "created_at", align: "left", style: 'width: 200px' },
			],
      especialidad: {},
      cursos: [],
      loading: false,
			pagination: {
				sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
			},
			per_page_options: [10, 20, 30, 40, 50, 100],
    };
  },

	watch: {
    // Hack: $router no detecta el cambio del parametro
    ["$route.params.especialidad"](especialidad) {
      this.loadEspecialidad()
    },
  },

	mounted() {
		this.loadEspecialidad();
		
	},

	methods: {
		async loadEspecialidad() {
			try {
				this.loading = true
				this.especialidad = await EspecialidadesAPI.get(this.$route.params.especialidad)
				this.loadCursos();
			} finally {
				this.loading = false
			}
		},

		async loadCursos(payload = {}) {
			const pagination = payload && payload.pagination ? payload.pagination : this.pagination
			
			try {
				this.loading = true
				const { data, ...response } = await CursosAPI.all({
					page: pagination.page,
					limit: pagination.rowsPerPage,
					order: {
						column: pagination.sortBy,
						direction: pagination.descending ? "desc" : "asc"
					},
					especialidad: this.especialidad.id
				})
				
				this.pagination = {
					page: response.current_page,
					rowsPerPage: Number(response.per_page),
					rowsNumber: response.total,
					sortBy: pagination.sortBy,
          			descending: pagination.descending,
				}
				
				this.cursos = data
			} finally {
				this.loading = false
			}
		},

		crearCurso() {
			this.$q.dialog({
				component: CursoForm,
				curso: {
					especialidades: [this.especialidad]
				}
			})
				.onOk((curso) => {
					this.loadCursos()
				})
		},

		editCurso(curso) {
			this.$q.dialog({
				component: CursoForm,
				curso
			})
				.onOk((curso) => {
					this.loadCursos()
				})
		},
	}
};
